export const APPVERSIONYDETAILS_INIT_ACTION = "APPVERSIONYDETAILS_INIT_ACTION"
export const APPVERSIONDETAILS_SUCCESS_ACTION = APPVERSIONYDETAILS_INIT_ACTION + '_SUCCESS'
export const APPVERSIONDETAILS_FAIL_ACTION = APPVERSIONYDETAILS_INIT_ACTION + '_ERROR'

export const FETCH_APPVERSION_INIT_ACTION = "FETCH_APPVERSION_INIT_ACTION"
export const FETCH_APPVERSION_SUCCESS_ACTION = FETCH_APPVERSION_INIT_ACTION + '_SUCCESS'
export const FETCH_APPVERSION_FAIL_ACTION = FETCH_APPVERSION_INIT_ACTION + '_ERROR'

export const EDIT_APPVERSION_INIT_ACTION = "EDIT_APPVERSION_INIT_ACTION"
export const EDIT_APPVERSION_SUCCESS_ACTION = EDIT_APPVERSION_INIT_ACTION + '_SUCCESS'
export const EDIT_APPVERSION_FAIL_ACTION = EDIT_APPVERSION_INIT_ACTION + '_ERROR'


export function appVrsnList() {

    return {
        type: FETCH_APPVERSION_INIT_ACTION
    }
}

export function editAppversion(value) {
  
     return {
         type: EDIT_APPVERSION_INIT_ACTION,
         value:value
     }
 }
